import { makeObservable, observable, action } from 'mobx';
import BaseObjectStore from './base-object.store';

class BarwisFileStore extends BaseObjectStore {
  isFileLoading = false;

  constructor(props) {
    super(props);
    this.name = 'barwisFile';
    makeObservable(this, {
      isFileLoading: observable,
      setIsFileLoading: action
    });
  }

  setIsFileLoading(isFileLoading) {
    this.isFileLoading = isFileLoading;
    return isFileLoading;
  }

  getIsFileLoading() {
    return this.isFileLoading;
  }

  resetAllFields() {
    this.resetAllBaseFields();
    this.setIsFileLoading(false);
  }
}

export default new BarwisFileStore();
